import {findLocationByName} from '@frontend/helpers/findLocationByName'
import type {
    AdLocation,
    AdLocations,
} from '@frontend/modules/public/ads/AdsModuleTypes'
import type {AdsStoreState} from '@frontend/stores'
import {findLocationBySlugWithId} from './findLocationBySlugWithId'

// Определить локацию для панели поиска при загрузке списка локаций.
export function detectSearchPanelLocationOnLoad(
    locations: AdLocations,
    searchPanelLocation: AdsStoreState['searchPanelLocation'],
    persistedLocationSlugWithId: string | null,
    defaultLocationName: string | null
): AdsStoreState['searchPanelLocation'] {
    if (searchPanelLocation !== undefined) {
        // Уже задано, не меняем.
        return searchPanelLocation
    }
    if (
        locations.tree.length === 0
        || (!persistedLocationSlugWithId && !defaultLocationName)
    ) {
        return null
    }
    if (persistedLocationSlugWithId) {
        const newLocation: AdLocation | null = findLocationBySlugWithId(
            locations.tree,
            persistedLocationSlugWithId
        )
        if (newLocation) {
            return newLocation
        }
    }
    // Локации нет в локальном хранилище, поэтому используем локацию
    // "по умолчанию" для локали.
    return findLocationByName(locations.tree, defaultLocationName)
}
